import React, { ButtonHTMLAttributes, FC } from 'react'

import { cn } from '@/lib/utils'

export type ButtonProps = {
  variant?: 'fill' | 'transparent'
  color?: 'green' | 'pink' | 'white' | 'black' | 'blue'
  size?: 'sm' | 'md' | 'full'
  as?: string
} & ButtonHTMLAttributes<HTMLButtonElement>

const variants = {
  fill: {
    white: 'bg-white text-red-torch hover:bg-black hover:text-white',
    pink: 'bg-red-torch text-white hover:bg-red-torch hover:text-red-torch',
    green:
      'bg-green-accent text-white hover:bg-green-accent hover:text-green-accent',
    black: 'bg-black text-white hover:bg-black hover:text-black',
    blue: 'bg-blue-accent text-white hover:bg-blue-accent hover:text-blue-accent',
  },
  transparent: {
    green: 'bg-transparent text-green-accent',
    pink: 'bg-transparent text-red-torch',
    white: 'bg-transparent text-white',
    black: 'bg-transparent text-black',
    blue: 'bg-transparent text-blue-accent',
  },
} as const

const Button: FC<ButtonProps> = ({
  id,
  variant = 'fill',
  color = 'pink',
  size = 'md',
  children,
  onClick,
  as: Component = 'button',
  type = 'button',
  className,
  ...rest
}) => {
  return (
    // @ts-expect-error it's fine
    <Component
      {...rest}
      id={id}
      type={type}
      onClick={onClick}
      className={cn(
        'whitespace-nowrap transition-all duration-100',
        size === 'full' ? 'w-full' : 'w-fit',
        'font-semibold text-sm',
        variants[variant][color],
        variant === 'transparent'
          ? size === 'sm'
            ? 'py-2'
            : 'py-4'
          : size === 'sm'
          ? 'py-2 px-3'
          : 'py-4 px-5.5',
        size === 'sm' ? 'rounded-sm' : 'rounded-lg',
        'cursor-pointer',
        variant === 'transparent'
          ? 'hover:article:gap-4'
          : `hover:rounded-md hover:bg-transparent hover:shadow-[inset_0px_0px_0px_2px]`,
        className
      )}
    >
      <span className="flex justify-center items-center gap-2 transition-all duration-100 rounded-lg">
        {children}
      </span>
    </Component>
  )
}

export default Button
